/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useRef, useState } from 'react';
import './style.less'
import { Link, NavLink, useNavigate,useLocation } from 'react-router-dom';
import logo from '@/assets/big_logo.png'
import useWindowScrollHeight from '@/hooks/useWindowScrollHeight';
import { AiOutlineDown } from "react-icons/ai";
import { Animated } from 'react-animated-css';
const NavBar = (props) => {
  const navigate = useNavigate()
  const location = useLocation()
  const pathName = location?.pathname
  const [showChild, setShowChild] = useState(-2)
  useEffect(() => {
    setTimeout(() => {
      setShowChild(-1)//animated會有初始動畫，延遲渲染盒子
    }, 500);
  }, [])
const {list} = props
  const getScrollHeight = useWindowScrollHeight()
  const navList = [
    { path: '/',key:'/', name: '首頁' },
    { path: '/precept',  key:'precept', name: '解決方案' },
    { path: '/contact',  key:'contact', name: '關於我們' },
    
  ]
  const navEnter = (index) => {
    setShowChild(index)
  }
  const NavClick = (path,event)=>{
    console.log(path)
    if(!path){
      event.preventDefault()
    }
  }
  return (
    <div className={`nav_bar ${getScrollHeight > 0 ? 'window_scroll' : ''}`}>
      <div className="nav_warp">
        <div className='logo'>
           <Link to={'/'}>
             <img src={logo} />
           </Link>
        </div>
        <div className='nav_list'>
          {
            navList.map((val, index) => {
              return <div className='nav_item'
                onMouseLeave={() => setShowChild(-1)}
                onMouseEnter={() => navEnter(index)}
              >
                <div className="nav_item_content">
                  <Link to={val.path} className={`${(pathName!=='/'&&val.key!=='/'&&pathName.indexOf(val.key)!=-1 )||(pathName==='/'&&val.key=='/')? "active" : ""}`} to={val.path}>
                    {val.name}
                  </Link>
                </div>
              </div>
            })
          }
        </div>
      </div>

    </div>
  );
}

export default NavBar;